// extracted by mini-css-extract-plugin
export default {"overlay":"_x-z","bodyOpen":"ay-z","content":"by-z","header":"cy-z","close":"dy-z","closeNoHeading":"ey-z"};